<div class="bg-white border m-1 py-3 px-3 shadow-sm overflow-hidden">
  <ng-content></ng-content>
</div>